export default {
	"Timezone": "Timezone",
	"Sample Record": "Sample Record",
	"Sync Normal": "Sync Normal",
	"SOS Phone": "SOS Phone",
	"Offline Timer": "Offline Timer",
	"Fall Detection": "Fall Detection",
	"Reference Systolic": "Reference Systolic",
	"Reference Diastolic": "Reference Diastolic",
	"Heart Rate Min": "Heart Rate Min",
	"Heart Rate Max": "Heart Rate Max",
}



// WEBPACK FOOTER //
// ./src/i18n/configurations/configurations_en-gb.js